import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import {
  AttachmentIconComponent,
  ChevronDownIconComponent,
  CloseIconComponent,
  FileDownloadIconComponent,
  FileIconComponent,
} from '@kuiper/icons';
import { NgTemplateOutlet } from '@angular/common';
import { Attachment } from '../../../../ui-components/lib/upload-files/attachment.interface';
import { TruncatePipe } from '../../../../ui-components/pipes/truncate/truncate.pipe';
import { Icon } from '../../models/icon.model';

@Component({
  selector: 'lib-view-file',
  imports: [
    TruncatePipe,
    FileDownloadIconComponent,
    FileIconComponent,
    CloseIconComponent,
    ChevronDownIconComponent,
    AttachmentIconComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './view-file.component.html',
  styleUrl: './view-file.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ViewFileComponent {
  label = input.required<string>();
  uploadedFiles = input.required<Attachment[] | (Icon | undefined)[]>();
  uploadFileLabels = input.required<{
    attachmentsTitle: string;
    singleFileUploadedLabel: string;
    multipleFilesUploadedLabel: string;
  }>();
  type = input<'icon' | 'input' | 'list'>('input');
  isMenuOpen = signal(false);

  toggleMenu() {
    this.isMenuOpen.set(!this.isMenuOpen());
  }
}
